import { v } from '@/lib/validator';

export default v.object().shape({
  email: v.string().email('Email inválido').required('Campo obrigatório'),
  password: v.string().required('Campo obrigatório'),
});
